<template>
    <!-- >>> 'CheckAll Pax & New Date on Flight Box' -->
    <div class="booking-details sdr-box" style="padding-left: 0px; padding-right: 0px; background-color: #dedede; color: #2d3e52; padding:7px;" v-bind:class="{ flightIsNotRebookable: !get_GotFlightsToRebook({ flightdirection: flightdirection }) }">
        <div class="row">
            <div class="col-xs-6">
                <div style="padding-top: 25px;">
                    <input type="checkbox" :id="'allPax_' + flightdirection" :name="'allPax_' + flightdirection" style="float: left; margin-right: 10px;" @change="onChange_Checkbox_AllPaxOnFlight($event)" :disabled="!get_GotFlightsToRebook({ flightdirection: flightdirection })">
                    <label :for="'allPax_' + flightdirection" v-if="flightdirection === 'outward'">{{ allpassengersoutward[getCurrentLocale] }}</label>
                    <label :for="'allPax_' + flightdirection" v-if="flightdirection === 'return'">{{ allpassengersreturn[getCurrentLocale] }}</label>
                </div>
            </div>

            <div class="col-xs-6">
                <label v-if="flightdirection === 'outward'">{{ newdateoutward[getCurrentLocale] }}</label>
                <label v-if="flightdirection === 'return'">{{ newdatereturn[getCurrentLocale] }}</label>
                <div class="" v-bind:class="{ 'datepicker-wrap': get_GotFlightsToRebook({ flightdirection: flightdirection }) }">
                    <input type="text" :id="'newDate_' + flightdirection" :name="'newDate_' + flightdirection" class="input-text full-width" :disabled="!get_GotFlightsToRebook({ flightdirection: flightdirection })">
                </div>
            </div>
        </div>
    </div>
    <!-- <<< 'CheckAll Pax & New Date on Flight Box' -->
</template>

<script>
    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['modulo', 'flightdirection'],
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* Data */
        data: function() {

            return {
                // >>> --------------------------
                allpassengersoutward: {
                    en: 'Select all passengers on Outward',
                    de: 'Alle Passagiere auf Hinflug auswählen',
                },
                allpassengersreturn: {
                    en: 'Select all passengers on Return',
                    de: 'Alle Passagiere auf Rückflug auswählen',
                },
                // >>> --------------------------
                newdateoutward: {
                    en: 'Select new outward flight date',
                    de: 'Neues Hinflugdatum wählen'
                },
                newdatereturn: {
                    en: 'Select new return flight date',
                    de: 'Neues Rückflugdatum wählen'
                },
            };

        }, // eo data
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'get_GotFlightsToRebook'
            ]),

        }, // eo computed
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc: Initialize Select Fields.
        * Note:
        *
        */
        mounted: function() {

            var me = this;


            me.$toc('>>> shared/forms/PackageToursTab.vue >>> mounted');
            me.$selectInits('services', this.getCurrentLocale);

        },  // eo function mounted()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_setRebookingAllPaxCheckboxClicked'
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onChange_Checkbox_AllPaxOnFlight()
            *
            * Desc: Save flightId (of clicked All Checkbox) in State.
            * Note:
            *
            */
            onChange_Checkbox_AllPaxOnFlight: function(e) {

                var me = this;


                me.$toc('>>> rebooking/pagecontents/CheckAllPax.vue >>> onChange_Checkbox_AllPaxOnFlight');
                this.actn_setRebookingAllPaxCheckboxClicked(e.target.id);

            }, // eo function onChange_Checkbox_AllPaxOnFlight()

        }, // eo methods
        /* <<< ****************************************************************/

    };
</script>



<style scoped>
    .flightIsNotRebookable {
        opacity: 0.3;
    }


    #flight-details .flights .first-flight .logo:after {
        bottom: 23px;
    }

    dl.term-description dt {
        color: #FDB714;
    }


    #flight-details .flights {
        padding-bottom: 0px; /* 30 */
    }


    .box {
        margin-bottom: 15px !important;
    }


    .booking-details .other-details {
        background-color: #f5f5f5;
    }
    .booking-details .other-details .total-price-value {
        font-size: 1.9167em;
    }
    .total-price-value-small {
        color: #98ce44;
        font-size: 1.4em;
        text-align: right;
    }
    .booking-details .other-details dt,
    .booking-details .other-details dd {
        padding-top: 0.4em;
        padding-bottom: 0.4em;
    }


    form label {
        text-transform: unset;
        display: block;
        margin-bottom: 5px;
        font-weight: normal;
        font-size: 1.2em;
    }

    input[type=checkbox] {
        transform: scale(1.2);
    }
</style>